/**
 * estados.js — los colores de cifra que no salen de un componente del DS.
 *
 * QUÉ QUEDÓ, Y POR QUÉ TAN POCO. Este archivo nació como el mapa único estado → variante del
 * DS para las diez pantallas de YoolPay: trece exports con los estados del período, del
 * giro, del cargo, del eje de descuadre y de la severidad de las advertencias. Al dejar
 * YoolPay en Mes → Día se borraron ocho de esas pantallas, y ninguno de esos mapas tiene ya
 * quien lo renderice. Un mapa sin consumidor no documenta una convención: documenta una
 * pantalla que no existe. Se fueron con ella.
 *
 * Sobrevive `CIFRA`, que es lo que el día sigue usando y lo que NO puede salir de un
 * componente: el color de una cifra suelta.
 *
 * POR QUÉ NO ES UNA PALETA DE COLORES
 * -----------------------------------
 * A propósito casi no define colores. `StatusPill` y `YoolBadge` ya llevan el color adentro:
 * si el estado se mapea a la variante correcta, el color sale gratis y sale bien. Definir
 * aquí una paleta paralela sería el CUARTO sistema de color de tadmin —ya conviven
 * `yoolBrand`, el tema shadcn/oklch de `styles/tokens/colors.js`, y el hex crudo de estas
 * pantallas—. Para lo que no es un componente (una cifra grande, el color de un contador)
 * está `CIFRA`, que apunta a variables CSS del DS, no a hex nuevo.
 *
 * LA REGLA SEMÁNTICA QUE ESTO HACE CUMPLIR
 * ----------------------------------------
 * Un significado por color. Las dos confusiones que cuestan plata:
 *
 *  1. Ámbar es «hay que mirarlo»; rojo es «no cuadra». No son intercambiables.
 *  2. El verde comunica un HECHO (se cobró, se giró), no la ausencia de un problema.
 *     Pintar de verde todo lo que no falla hace que el verde deje de significar algo.
 *
 * OJO CON LA VARIANTE `vence`
 * ---------------------------
 * El DS define `--badge-vence-text: #D35400`, que es naranja, y el naranja está prohibido en
 * las pantallas de pagos. Si alguna vez hace falta, se corrige el token en el DS primero; no
 * se reintroduce el naranja aquí.
 *
 * @see src/components/ui/YoolTable.jsx — el mapa PILL que consume StatusPill
 */

export const CIFRA = {
  /** Texto normal. Una cifra que cuadra va así, no en verde. */
  tinta: 'var(--yool-black)',
  /** Texto de cuerpo / cifra secundaria. */
  cuerpo: 'var(--yool-gray1)',
  /** Cifra sin relevancia, o contador en cero. */
  apagado: 'var(--yool-muted)',
  /** Cobrado, girado, aprobado — un hecho consumado. */
  verde: 'var(--badge-protegido-text)',
  /** Hay que mirarlo, no está roto. */
  ambar: 'var(--badge-pendiente-text)',
  /** No cuadra, rechazado, fallido. */
  rojo: 'var(--badge-vencido-text)',
  /** Informativo, en curso, esperando al PSP. */
  celeste: 'var(--badge-digital-text)',
  /** Pago dividido. */
  violeta: 'var(--badge-recomendado-text)',
};
